var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevelProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Level_progress"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Level_progress",
    clipPath: "url(#clip-Level_progress)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2120",
    "data-name": "Group 2120",
    transform: "translate(4 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M.942,413.168A.942.942,0,0,0,0,414.11v7.466a.942.942,0,0,0,.942.942h9.881v-9.351Zm0,0",
    transform: "translate(0 -374.078)",
    fill: "#acd6fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M2.924,332.091v-7.466a.943.943,0,0,1,.942-.942H.942a.943.943,0,0,0-.942.942v7.466a.942.942,0,0,0,.942.942H3.866a.942.942,0,0,1-.942-.942Zm8.646-17.759a.943.943,0,0,0-.942.942v17.759H21.451v-18.7Zm0,0",
    transform: "translate(0 -284.593)",
    fill: "#8ac2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M116.2,224.85h-2.924a.943.943,0,0,0-.942.942v17.759h2.924V225.793a.942.942,0,0,1,.942-.942Zm7.7-9.35a.942.942,0,0,0-.942.942v27.11h10.823V215.5Zm0,0",
    transform: "translate(-101.704 -195.112)",
    fill: "#54a0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M228.531,126.015h-2.924a.942.942,0,0,0-.942.942v27.11h2.924v-27.11A.942.942,0,0,1,228.531,126.015Zm16.447-9.351h-8.743a.942.942,0,0,0-.942.942v36.46h9.685a.942.942,0,0,0,.942-.942V117.606a.942.942,0,0,0-.942-.942Zm0,0",
    transform: "translate(-203.409 -105.626)",
    fill: "#338def"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M340.866,116.664h-2.924a.942.942,0,0,0-.942.942v36.46h2.924v-36.46a.942.942,0,0,1,.942-.942Zm0,0",
    transform: "translate(-305.116 -105.626)",
    fill: "#2388e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M48.623,39.373a.731.731,0,0,1,.066-1.032L80.572,10.29a.731.731,0,0,1,.966,1.1L49.654,39.439a.731.731,0,0,1-1.032-.066Zm0,0",
    transform: "translate(-43.857 -9.151)",
    fill: "#e4eaf8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2119",
    "data-name": "Group 2119",
    transform: "translate(3.627 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M41.707,29.739a1.687,1.687,0,1,1-1.687-1.687A1.687,1.687,0,0,1,41.707,29.739Zm10.628-9.351A1.687,1.687,0,1,1,50.647,18.7,1.687,1.687,0,0,1,52.334,20.388Zm10.628-9.351a1.687,1.687,0,1,1-1.687-1.687A1.687,1.687,0,0,1,62.962,11.038ZM73.59,1.687A1.687,1.687,0,1,1,71.9,0,1.687,1.687,0,0,1,73.59,1.687Zm0,0",
    transform: "translate(-38.332)",
    fill: "#feca57"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M40.72,29.739a1.681,1.681,0,0,1,.493-1.192,1.687,1.687,0,1,0,0,2.384A1.681,1.681,0,0,1,40.72,29.739Zm10.628-9.351a1.681,1.681,0,0,1,.493-1.192,1.687,1.687,0,1,0,0,2.384,1.681,1.681,0,0,1-.493-1.192Zm10.628-9.351a1.681,1.681,0,0,1,.493-1.192,1.687,1.687,0,1,0,0,2.384,1.681,1.681,0,0,1-.493-1.192ZM72.6,1.687A1.683,1.683,0,0,1,73.1.5a1.687,1.687,0,1,0,0,2.384A1.682,1.682,0,0,1,72.6,1.687Zm0,0",
    transform: "translate(-34.705 0)",
    fill: "#f4b537"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelProgress);
export default __webpack_public_path__ + "static/media/Level_progress.6ab731bc.svg";
export { ForwardRef as ReactComponent };